"use client";

import { motion } from "framer-motion";

interface SectionWrapperProps {
  id: string;
  children: React.ReactNode;
  titleColor?: string;
  bgClass?: string;
}

export default function SectionWrapper({
  id,
  children,
  titleColor,
  bgClass,
}: SectionWrapperProps) {
  return (
<motion.section
  id={id}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.2 }}
  className={`py-20 px-4 ${bgClass}`}
>
  <motion.div
    variants={{
      hidden: { opacity: 0, y: 40 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.2 } },
    }}
  >
    {children}
  </motion.div>
</motion.section>

  );
}










 